import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  checkArray,
  checkNull,
  createSelectOptions,
} from "../../../../helpers";
import {
  addFinanceReconcileSettings,
  changeSettingValue,
  deleteFinanceReconcileSettings,
  getFinanceReconcileSettings,
} from "../../../../Redux/actions";
import Headerbar from "../../../Components/InnerLayout/Headerbar";
import UserInterface from "../../../Components/InnerLayout/UserInterface";
import ModelContainer from "../../../Components/ModelContainer";
import ErrorContainer from "../../../Components/ErrorContainer";
import LoadingIcon from "../../../Components/LoadingIcon";

const addReconcileSchema = yup
  .object({
    finance_account_id: yup.string().required(),
  })
  .required();

const FinanceReconcile = (params) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const {
    reconcile_detail,
    addReconcileModal,
    is_addReconcileModal_loading,
    delete_reconcile_id,
    redirect_reconcile_id,
  } = useSelector((state) => state.settingReducer);

  const initialAddReconcileForm = {
    finance_account_id: "",
  };
  const [addReconcileInputForm, setAddReconcileInputForm] = useState(
    initialAddReconcileForm
  );

  const {
    register: addReconcileReg,
    formState: { errors: addReconcileErrors },
    handleSubmit: addReconcileSubmit,
    control: addReconcileControl,
    setValue: addReconcileSetValue,
    reset: addReconcileReset,
  } = useForm({
    resolver: yupResolver(addReconcileSchema),
    defaultValues: initialAddReconcileForm,
    mode: "all",
    reValidateMode: "onChange",
  });

  const closeAddReconcileModal = useCallback(
    (value) => {
      dispatch(changeSettingValue("addReconcileModal", value));
      resetAddReconcileHandler();
    },
    [addReconcileModal]
  );

  const changeAddReconcileInputHandler = (input, val) => {
    addReconcileSetValue(input, val);
    setAddReconcileInputForm((prevState) => ({
      ...prevState,
      [input]: val,
    }));
  };

  useEffect(() => {
    dispatch(getFinanceReconcileSettings());
    dispatch(changeSettingValue("redirect_reconcile_page", false));
  }, []);

  useEffect(() => {
    if (checkNull(redirect_reconcile_id, false))
      editReconcileHandler(redirect_reconcile_id);
  }, [redirect_reconcile_id]);

  const editReconcileHandler = (reconId) => {
    history.push(`/settings/finance/reconcile/upload-settings/${reconId}`);
  };

  const resetAddReconcileHandler = (resetVal = initialAddReconcileForm) => {
    setAddReconcileInputForm(resetVal);
    addReconcileReset(resetVal);
  };

  const deleteAccHandler = (accId) => {
    dispatch(deleteFinanceReconcileSettings({ id: accId }));
  };
  const addRecSubmitHandler = (data) => {
    console.log("addRecSubmitHandler", data);
    dispatch(addFinanceReconcileSettings(data));
  };

  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />

        <div className="inner-content row mx-0 finance-setting-chart chart-of-accounts">
          <div className="container px-0">
            <div className="row mx-0">
              <div className="container px-0">
                <div className="top-header-sec">
                  <div className="col-12 mt-3">
                    <h4 className="event-alert br-btm-0">
                      Account Upload List
                      <div className="clear"></div>
                    </h4>
                  </div>
                </div>
                <div className="shadowclass mt-0">
                  <div class="table-responsive">
                    <table class="checklist-table remove-space inventory_table">
                      <thead>
                        <tr>
                          <th className="second-th">
                            <a href="#_">Account Name</a>
                          </th>
                          <th class="action-td"> Actions </th>
                        </tr>
                      </thead>
                      <tbody>
                        {checkArray(reconcile_detail?.allAcs) &&
                          reconcile_detail?.allAcs.map((acs) => {
                            return (
                              <tr>
                                <td class="second-td">
                                  {acs?.finance_account?.name}
                                </td>
                                <td class="">
                                  <a
                                    onClick={() =>
                                      editReconcileHandler(acs?.id)
                                    }
                                    class="circle_icon editApFinance"
                                  >
                                    <i class="iconSprites edit-icon">
                                      <div class="tooltip-sm"> Edit </div>
                                    </i>
                                  </a>
                                  <a
                                    // href="#_"
                                    onClick={() => deleteAccHandler(acs?.id)}
                                    className="circle_icon red"
                                  >
                                    <LoadingIcon
                                      is_loading={
                                        delete_reconcile_id == acs?.id
                                      }
                                      className="iconSprites delete-icon"
                                    ></LoadingIcon>
                                  </a>
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                    <div class="my-3">
                      <button
                        class="btn green-btn-revert add-plus addSp"
                        id="addCount"
                        type="button"
                        onClick={() => closeAddReconcileModal(true)}
                      >
                        <i class="i-icon"> </i> Add Account
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ModelContainer
        title={`Add Account`}
        open={addReconcileModal}
        submitModal={addReconcileSubmit(addRecSubmitHandler)}
        closeModal={closeAddReconcileModal}
        is_loading={is_addReconcileModal_loading}
      >
        <fieldset class="">
          <ul class="form-list label-group new-form">
            <li>
              Select Account
              <div class="input-wrap select-div">
                <select
                  {...addReconcileReg("finance_account_id")}
                  name="data[ReconcileSetting][finance_account_id]"
                  class="required"
                  id="ReconcileSettingFinanceAccountId"
                  onChange={(e) =>
                    changeAddReconcileInputHandler(
                      "finance_account_id",
                      e?.target?.value
                    )
                  }
                  value={addReconcileInputForm?.finance_account_id}
                >
                  <option value="">Select</option>
                  {createSelectOptions(reconcile_detail?.accounts)}
                </select>{" "}
                <ErrorContainer
                  errors={addReconcileErrors}
                  name="finance_account_id"
                />
              </div>
            </li>
          </ul>
        </fieldset>
      </ModelContainer>
    </UserInterface>
  );
};
export default FinanceReconcile;
